import { render, staticRenderFns } from "./addGoodsToStore.vue?vue&type=template&id=dc73e526"
import script from "./addGoodsToStore.vue?vue&type=script&lang=js"
export * from "./addGoodsToStore.vue?vue&type=script&lang=js"
import style0 from "./addGoodsToStore.vue?vue&type=style&index=0&id=dc73e526&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dc73e526')) {
      api.createRecord('dc73e526', component.options)
    } else {
      api.reload('dc73e526', component.options)
    }
    module.hot.accept("./addGoodsToStore.vue?vue&type=template&id=dc73e526", function () {
      api.rerender('dc73e526', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/salesControl/publish/addGoodsToStore.vue"
export default component.exports